import React, {FC} from 'react';
import styled from 'styled-components';

import {Skeleton, SkeletonColorSchemesEnum} from '../../../../components/common/skeleton';
import {AnalyticsExportsModel} from '../../../../models/api/analyticsExportModel';
import {ReportGridItem} from '../../reportViewer/reportGrid';
import {AnalyticsExportDialogItem} from '../analyticsExportDialogItem';
import {PaddedGridItemDiv} from './common';

/*
 * Style.
 */

const StyledExportsScrollerDiv = styled.div`
  overflow-y: auto;
  max-height: 200px;
`;

/*
 * Props.
 */

export interface ExportItemListProps {
  exportItems: AnalyticsExportsModel;
  isLoading?: boolean;
}

/*
 * Component.
 */

export const ExportItemList: FC<ExportItemListProps> = ({exportItems, isLoading}) => {
  if (isLoading) {
    return renderLoadingState();
  }

  return (
    <StyledExportsScrollerDiv>
      {exportItems.map((exportItem) => (
        <AnalyticsExportDialogItem key={exportItem.filename} exportItem={exportItem} />
      ))}
    </StyledExportsScrollerDiv>
  );
};

/*
 * Helpers.
 */

function renderLoadingState() {
  return (
    <PaddedGridItemDiv>
      <ReportGridItem>
        <Skeleton width="100%" height="26px" borderRadius="50px" scheme={SkeletonColorSchemesEnum.GREY10} />
      </ReportGridItem>
    </PaddedGridItemDiv>
  );
}
